import {
  CONSENT_CHANGED_EVENT,
  hasAnalyticsConsent,
  isMarketingAttributionCookieConsentGateEnabled,
} from 'common/utils/cookie-consent';
import { readCookie } from 'common/utils/browser-cookie';

function getParameterByName(name, url) {
  const targetUrl = url || window.location.href;
  const escapedName = name.replace(/\[|\]/g, '\\$&');
  const regex = new RegExp(`[?&]${escapedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(targetUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function createCookie(name, value, days) {
  if (!value) {
    return;
  }
  let expires = '';
  const duration = days || 90;
  const date = new Date();
  date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1e3);
  expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}${expires};domain=${document.location.hostname};path=/`;
}

function getAttribution() {
  return {
    gclid: getParameterByName('gclid'),
    par: getParameterByName('par'),
    referrer: document.referrer,
    landingPage: document.location.href,
  };
}

function applyAttribution({ gclid, par, referrer, landingPage }) {
  createCookie('gclid_lt', gclid);
  createCookie('par_lt', par);
  createCookie('referrer_url_lt', referrer);
  createCookie('landing_page_url_lt', landingPage);

  if (gclid && readCookie('gclid') === null) {
    createCookie('gclid', gclid);
  }
  if (par && readCookie('par') === null) {
    createCookie('par', par);
  }
  if (readCookie('referrer_url') === null) {
    createCookie('referrer_url', referrer);
  }
  if (readCookie('landing_page_url') === null) {
    createCookie('landing_page_url', landingPage);
  }
}

export function initializeMarketingAttribution() {
  const attribution = getAttribution();

  if (isMarketingAttributionCookieConsentGateEnabled()) {
    window.addEventListener(CONSENT_CHANGED_EVENT, () => {
      if (hasAnalyticsConsent()) {
        applyAttribution(attribution);
      }
    });

    if (hasAnalyticsConsent()) {
      applyAttribution(attribution);
    }
  } else {
    applyAttribution(attribution);
  }
}
